import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductStory from './components/ProductStory';
import ScienceSection from './components/ScienceSection';
import TestimonialsSection from './components/TestimonialsSection';
import ProductBenefits from './components/ProductBenefits';
import SpecialOffer from './components/SpecialOffer';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import ArticleHeader from './components/ArticleHeader';
import TableOfContents from './components/TableOfContents';
import SocialShareBar from './components/SocialShareBar';
import ReadingProgressBar from './components/ReadingProgressBar';
import LiveActivityIndicator from './components/LiveActivityIndicator';
export function App() {
  return <div className="w-full bg-gradient-to-b from-white to-green-50 min-h-screen relative" data-id="element-0">
      <ReadingProgressBar data-id="element-1" />
      {/* Decorative elements - only visible on desktop */}
      <div className="hidden md:block" data-id="element-2">
        <div className="absolute top-40 left-0 w-32 h-32 bg-green-100 rounded-full opacity-30 -z-10 blur-xl" data-id="element-3"></div>
        <div className="absolute top-[30%] right-0 w-40 h-40 bg-green-100 rounded-full opacity-30 -z-10 blur-xl" data-id="element-4"></div>
        <div className="absolute top-[60%] left-0 w-48 h-48 bg-green-100 rounded-full opacity-30 -z-10 blur-xl" data-id="element-5"></div>
        <div className="absolute top-[80%] right-0 w-36 h-36 bg-green-100 rounded-full opacity-30 -z-10 blur-xl" data-id="element-6"></div>
        {/* Leaf decorations */}
        <div className="absolute top-[15%] right-5 w-20 h-20 opacity-20 -z-10" data-id="element-7">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-8">
            <path d="M21 3V5C21 14.627 14.627 21 5 21H3" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-9" />
            <path d="M21 12C14.5 12 12 9.5 12 3" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-10" />
          </svg>
        </div>
        <div className="absolute top-[45%] left-5 w-16 h-16 opacity-20 -z-10 rotate-45" data-id="element-11">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-12">
            <path d="M21 3V5C21 14.627 14.627 21 5 21H3" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-13" />
            <path d="M21 12C14.5 12 12 9.5 12 3" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-14" />
          </svg>
        </div>
        <div className="absolute top-[75%] right-8 w-14 h-14 opacity-20 -z-10 -rotate-45" data-id="element-15">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-16">
            <path d="M21 3V5C21 14.627 14.627 21 5 21H3" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-17" />
            <path d="M21 12C14.5 12 12 9.5 12 3" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-18" />
          </svg>
        </div>
      </div>
      <Header data-id="element-19" />
      <div className="max-w-4xl mx-auto px-4 py-4 relative" data-id="element-20">
        {/* Subtle pattern overlay */}
        <div className="hidden md:block absolute inset-0 bg-opacity-5 -z-10" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%2316a34a' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        backgroundSize: '150px 150px'
      }} data-id="element-21"></div>
        {/* Main content with enhanced paper effect on desktop */}
        <div className="md:bg-white md:shadow-xl md:rounded-2xl md:p-8 md:mt-6 md:mb-10 relative" data-id="element-22">
          <ArticleHeader data-id="element-23" />
          <div className="md:flex md:gap-8 mt-6" data-id="element-24">
            <div className="hidden md:block md:w-1/4 relative" data-id="element-25">
              <div className="sticky top-6" data-id="element-26">
                <TableOfContents data-id="element-27" />
                <SocialShareBar data-id="element-28" />
                <LiveActivityIndicator data-id="element-29" />
              </div>
            </div>
            <div className="md:w-3/4" data-id="element-30">
              <Hero data-id="element-31" />
              <ProductStory data-id="element-32" />
              <ScienceSection data-id="element-33" />
              <TestimonialsSection data-id="element-34" />
              <ProductBenefits data-id="element-35" />
              <SpecialOffer data-id="element-36" />
              <Footer data-id="element-37" />
            </div>
          </div>
        </div>
      </div>
      <StickyCTA data-id="element-38" />
    </div>;
}